import Collapse from "@mui/material/Collapse";
import { IDetailsProps } from "./types";

const Details = ({ open = false, unmountOnExit = false, children }: IDetailsProps) => {
    return (
        <Collapse in={open} unmountOnExit={unmountOnExit}>
            {children}
        </Collapse>
    );
};

export { Details };

